import { createRouter, createWebHistory } from 'vue-router'

const asyncRouterConfig = [
    // 登录
    // {
    //     path: '/LayoutHome',
    //     name: 'LayoutHome',
    //     component: () => import(/* webpackChunkName: "LayoutHome" */ '../components/LayoutHome/index.vue'),
    //     meta: { title: '大框架' },
    //     children: []
    // },
    {
        path: '/',
        name: 'large-data-screen',
        component: () => import(/* webpackChunkName: "LargeDataScreen" */ '../views/large-data-screen/index.vue'),
        meta: { title: '看板' },
        children: []
    }
]

const router = createRouter({
    routes: asyncRouterConfig,
    history: createWebHistory(import.meta.env.MODE === 'dev' ? './' : './'),
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    }
})

export default router
